import type { PropsWithChildren, ReactElement } from 'react'

import type { Tutorial } from './VideoTutorialModal'
import { useVideoTutorialSetter } from './VideoTutorialContext'

type VideoTutorialButtonProps = PropsWithChildren<{
  tutorial: Tutorial
}>

export default function VideoTutorialButton({ tutorial, children }: Readonly<VideoTutorialButtonProps>): ReactElement {
  const setter = useVideoTutorialSetter()

  const handleClick = () => {
    setter(tutorial)
  }

  return (
    <button onClick={handleClick} className="show-video-tutorial-button">
      {children}
    </button>
  )
}
